<template>
  <sliderBarDialogShell
    ref="sliderbar"
    :dialog-show="dialogShow"
    :dialog-title="title"
    @close="close"
    @submit="confirm"
    class="editLark"
  >
    <lark-form
      ref="form"
      :form-data="formData"
      @submit="submitHandle"
    ></lark-form>
  </sliderBarDialogShell>
</template>

<script>
import { editLarkConfig } from '@/api/sys/robitConfig/lark'
import larkForm from '@/components/sys/robitCofig/lark/larkForm'

export default {
  name: 'editLark',
  components:{
    larkForm,
  },
  props: {
    dialogShow: {
      type: Boolean,
      default: false
    },
    formData: {
      type: Object
    }
  },
  data() {
    return {
      title: '编辑Lark推送渠道',
    }
  },

  methods: {
    close(){
      this.$refs.form.$refs.form.clearValidate();
      this.$emit('close');
    },

    cancel(){
      this.close();
    },
    confirm() {
      this.$refs.form.validate();
    },
    submitHandle(params){
        editLarkConfig(params).then((res) => {
            this.$refs.form.$refs.form.clearValidate();
            this.$refs.form.$refs.form.resetFields();
            this.$emit('edit-success');
            this.$refs.form.reset();
        });
    }
  }
}
</script>

<style>
@media screen and (min-width: 768px) {
  .editLark.sidebar-dialog .vs-sidebar {
    width: 800px;
  }
}
</style>
